import store from '@/store';
import ScheduleDashboard from '@/modules/schedule/views/Dashboard';
import ScheduleDay from '@/modules/schedule/views/scheduleDetail/Day';
import ScheduleWeek from '@/modules/schedule/views/scheduleDetail/Week';
import ScheduleMonth from '@/modules/schedule/views/scheduleDetail/Month';
import RouteHealthCheck from '../views/RouteHealthCheck';
import DivisionRoutingPage from '../views/divisionRouting/Base';
import OfficeCalendar from '@/modules/schedule/views/calendars/OfficeCalendar';

const routes = [
  {
    path: '/schedules/',
    component: () => import('@/modules/schedule/components/ModuleBase'),
    meta: { appKey: 'schedule' },
    children: [
      {
        path: 'dashboard',
        component: ScheduleDashboard,
        name: 'ScheduleDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'route-health-check/:id',
        component: RouteHealthCheck,
        name: 'RouteHealthCheck'
      }
    ]
  },
  {
    path: '/schedule-detail/:id',
    component: () => import('@/modules/schedule/views/scheduleDetail/Base'),
    meta: { appKey: 'schedule' },
    children: [
      {
        path: 'week/:date',
        component: ScheduleWeek,
        name: 'ScheduleWeek'
      },
      {
        path: 'day/:date',
        component: ScheduleDay,
        name: 'ScheduleDay'
      },
      {
        path: 'month/:date',
        component: ScheduleMonth,
        name: 'ScheduleMonth'
      }
    ]
  },
  {
    path: '/map-route/:id',
    component: () => import('@/modules/schedule/components/MapRoute'),
    meta: { appKey: 'schedule', forPrinting: true },
    // forPrinting is to make display full screen (no top and side menu)
    name: 'MapRoute'
  },
  {
    path: '/project-routing/',
    component: () => import('@/modules/schedule/views/divisionRouting/ModuleBase'),
    meta: { appKey: 'schedule' },
    children: [
      {
        path: 'division/:id',
        component: DivisionRoutingPage,
        name: 'DivisionRoutingPage',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      }
    ]
  },
  {
    path: '/calendars/',
    component: () => import('@/modules/schedule/views/calendars/Base'),
    meta: { appKey: 'schedule' },
    children: [
      {
        path: 'calendar/:id',
        component: OfficeCalendar,
        name: 'OfficeCalendar',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      }
    ]
  }
]

export default routes
